export const locationPreviewRBAC = {
  pageID: 'cccab618a179fc8fcffd988db1a8d502',
  elementID: {
    ViewIsochrone: 'f8d4ea93244e4056c52237e576bbaf67',
  },
} as const
